import React, { useEffect, useState } from 'react';


import { toast } from 'react-toastify';

const Login = ({ setAuth, setCurrentPage }: { setAuth: Function; setCurrentPage: Function; }) => {

    const apiUrl = process.env.REACT_APP_API_URL;

    const [inputs, setInputs] = useState({
        email: '',
        senha: ''
    });

    const { email, senha } = inputs;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputs({ ...inputs, [e.target.name]: e.target.value });
    };

    const onSubmitForm = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const body = { senha, email };
            const response = await fetch(`${apiUrl}/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" }
                ,
                body: JSON.stringify(body)
            });
            const parseRes = await response.json();
            if (parseRes.token) {
                localStorage.setItem("token", parseRes.token);
                setAuth(true);
                toast.success("Logado com sucesso!");
            } else {
                setAuth(false);
                toast.error(parseRes);
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        setCurrentPage(window.location.pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="d-flex justify-content-center">
            <div className="card m-5" style={{ maxWidth: '600px' }}>
                <div className="card-header">
                    <h4 className='m-0'>Login</h4>
                </div>
                <div className="card-body">
                    <div className="input-group mb-3">
                        <span className="input-group-text" id="basic-addon1">
                            <i className="bi bi-envelope pe-3"></i>
                            Email
                        </span>
                        <input type="text" className="form-control" placeholder="email@email.com" aria-label="email" name='email' aria-describedby="basic-addon1" value={email} onChange={e => onChange(e)} />
                    </div>
                    <div className="input-group mb-3">
                        <span className="input-group-text" id="basic-addon1">
                            <i className="bi bi-key pe-3"></i>
                            Senha
                        </span>
                        <input type="password" className="form-control" placeholder="********" aria-label="senha" name='senha' aria-describedby="basic-addon1" value={senha} onChange={e => onChange(e)} />
                    </div>
                </div>
                <button className='btn btn-primary m-3' onClick={e => onSubmitForm(e)}>entrar</button>
            </div >
        </div>
    );
};

export default Login;
